export default __webpack_public_path__ + "static/media/bg_burst.8aed8488.png";